import axios from "axios";

const API_URL =
  process.env.REACT_APP_API_URL || "http://localhost:5000/api/rss";

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "http://localhost:5000/api";

// -------------------------------
// Generic fetch by category
// -------------------------------
export const fetchNewsByCategory = async (category) => {
  try {
    const response = await axios.get(`${API_URL}/${category}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching ${category} news:`, error);
    return [];
  }
};

// -------------------------------
// NEWS CATEGORIES
// -------------------------------
export const fetchBharatNews = async () => {
  return fetchNewsByCategory("bharat");
};

export const fetchGlobalNews = async () => {
  return fetchNewsByCategory("global");
};

export const fetchSportsNews = async () => {
  return fetchNewsByCategory("sports");
};

export const fetchFinanceNews = async () => {
  return fetchNewsByCategory("finance");
};

export const fetchTechnologyNews = async () => {
  return fetchNewsByCategory("technology");
};

export const fetchAutoNews = async () => {
  return fetchNewsByCategory("auto");
};

// -------------------------------
// SPORTS CATEGORIES
// -------------------------------
export const fetchCricketNews = async () => {
  return fetchNewsByCategory("cricket");
};

export const fetchGolfNews = async () => {
  return fetchNewsByCategory("golf");
};

export const fetchHockeyNews = async () => {
  return fetchNewsByCategory("hockey");
};

export const fetchNFLNews = async () => {
  return fetchNewsByCategory("nfl");
};

export const fetchNBANews = async () => {
  return fetchNewsByCategory("nba");
};

export const fetchSoccerNews = async () => {
  return fetchNewsByCategory("soccer");
};

export const fetchChessNews = async () => {
  return fetchNewsByCategory("chess");
};

export const fetchNHLNews = async () => {
  return fetchNewsByCategory("nhl");
};

export const fetchMLBNews = async () => {
  return fetchNewsByCategory("mlb");
};

export const fetchTennisNews = async () => {
  return fetchNewsByCategory("tennis");
};

// -------------------------------
// OTHER ENDPOINTS
// -------------------------------
export const fetchHomeMasters = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/homemasters`);
    return response.data;
  } catch (error) {
    console.error("Error fetching home masters:", error);
    return [];
  }
};
